import React, { useLayoutEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useViewport } from 'components/general/useViewPort'
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useDispatchLegends, useLegends } from "components/common/legendContext";

function getBreakPoints(data, competition, discipline, breakPoint = "xs") {
    //CTO-DEPORTE-SIZE
    //CTO--SIZE
    //DEPORTE-SIZE
    //SIZE= xs,sm,md,lg,xl,xxl,default

    const mediaQueries = ["xs", "sm", "md", "lg", "xl", "xxl", "default", "legend"];
    const index = mediaQueries.indexOf(breakPoint);
    const mediaQueriesFilter = mediaQueries.slice(index, mediaQueries.length);
    let compose = mediaQueriesFilter.map(media => data + "." + media)
    let composeDiscipline = mediaQueriesFilter.map(media => data + "." + discipline + "." + media)
    let composeCompetition = mediaQueriesFilter.map(media => data + "." + competition + "." + media)
    let composeCompetitionDiscipline = mediaQueriesFilter.map(media => data + "." + competition + "." + discipline + "." + media)
    let out = [...composeCompetitionDiscipline, ...composeCompetition, ...composeDiscipline, ...compose]
    return out

}
export default function Label({ data, values, disableLegend, showAlways, abbrValue, legendFixed, expandedId, tooltip = false, noHtml = false, ocsLabel = false }) {
    const { mirs_competition, mirs_discipline } = useUrlFriendlyToParameters();
    const { t, i18n } = useTranslation(['labels']);
    const { breakPoint } = useViewport();
    const breaksPointsList = getBreakPoints(data, mirs_competition, mirs_discipline, breakPoint)
    const breaksPointsListDefault = getBreakPoints(data, mirs_competition, mirs_discipline, "default")
    const breaksPointsListLegend = getBreakPoints(data, mirs_competition, mirs_discipline, "legend")
    const dispatch = useDispatchLegends() ?? null;


    const defaultTranslation = data ? t(breaksPointsListDefault, values) : null;
    const legendDesc = data ? t(i18n.exists(breaksPointsListLegend) ? breaksPointsListLegend : breaksPointsListDefault, values) : null;
    const translation = data ? t(breaksPointsList, values) : null;



    useLayoutEffect(() => {
        if ((showAlways && dispatch) || (dispatch && !disableLegend && defaultTranslation !== null && needsLegend(legendDesc, translation))) {
            const payload = { id: abbrValue ? abbrValue : translation, name: legendDesc, legendFixed: legendFixed, expandedId: expandedId }
            dispatch({
                type: 'addlegend',
                payload: payload
            })
        }
    })

    let text
    if (tooltip) {
        text = <><abbr aria-hidden="true" title={legendDesc}>{abbrValue ? abbrValue : translation}</abbr><span className="sr-only">{legendDesc}</span></>
    } else {
        text = translation
    }

    let out
    if (ocsLabel) {
        out = <span data-ocs-label={data}>{text}</span>
    }  else if (translation && translation.includes("\n")) {
        out = <span data-ocs-label={data} style={{ whiteSpace: "pre-line" }}>{text}</span>
    } else {
        out = text
    }
    return out;
}

//Used to check if a certain label needs legend
function needsLegend(defaultTranslation, translation) {
    if (!defaultTranslation || !translation) { return false }
    const cleanTranslation = translation.replace(/(\r\n|\n|\r|\s)/gm, "");
    const cleanDefaultTranslation = defaultTranslation.replace(/(\r\n|\n|\r|\s)/gm, "");
    return cleanTranslation !== cleanDefaultTranslation
}

export function useLabels() {
    const { mirs_competition, mirs_discipline } = useUrlFriendlyToParameters();
    const { t } = useTranslation(['labels']);
    const { breakPoint } = useViewport();

    return function ({ data, values }) {
        const breaksPointsList = getBreakPoints(data, mirs_competition, mirs_discipline, breakPoint)
        const translation = data ? t(breaksPointsList, values) : null;
        return translation;

    }
}